import { Link } from 'react-router-dom'

import NativeLink from './NativeLink'

export default NativeLink.withComponent(Link)
